var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('big-title',[_vm._v(" Banco"),_c('span',[_vm._v(".")])]),(_vm.isMounted)?_c('investor-bank-accounts',{attrs:{"is-moral":_vm.isMoral,"person-type":_vm.investorType,"user-id":_vm.currentInvestorUserId,"has-backoffice-access":_vm.hasBackofficeAccess,"user-data":_vm.base}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }